export const API_LINKS = {
  BASE: "http://185.208.175.126/iranrey/api/controllers",
  BASE_PIC: "http://185.208.175.126/iranrey/api/pictures/",
  LABORATORY: {
    LOGIN: "/laboratories/login.php",
    SIGNUP: "/laboratories/add.php",
  },
  PACKET: {
    ADD: "/packet/add.php",
    UPDATE: "/packet/update.php",
    INQUIRY: "/packet/inquiry.php",
    INQUIRY_FOR_EDIT: "/packet/inquiryForEdit.php",
  },
  PACKET_NUMBERS: {
    ADD: "/packetNumbers/add.php",
    RANGE: "/packetNumbers/range.php",
  },
};
